/**
 * React Query mutation hook for capturing a manual config snapshot.
 *
 * Fired from the "Créer une sauvegarde" button on the backups table. On
 * success the snapshot list is invalidated so the freshly-captured backup
 * appears at the top.
 */

import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from '@tanstack/react-query';

import {
  configVersioningService,
  type ConfigSnapshot,
} from '../../api/configVersioningService';
import { configVersioningKeys } from './queryKeys';

export interface CreateSnapshotVars {
  /** Optional human-readable label (max 200 chars, trimmed server-side). */
  label?: string;
}

export function useCreateSnapshot(): UseMutationResult<
  ConfigSnapshot,
  Error,
  CreateSnapshotVars
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ label }: CreateSnapshotVars) =>
      configVersioningService.createSnapshot(label),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: configVersioningKeys.snapshotList(),
      });
    },
  });
}
